import { api } from './api';

export interface InviteDetails {
  schoolName: string;
  inviterName: string | null;
  email: string;
  role: 'teacher' | 'school_leader';
  /** EducAitor set this organisation up for them to own (absent on older APIs). */
  makeOwner?: boolean;
  /** For one person's own account (no organisation or team). */
  personal?: boolean;
  status: 'open' | 'used' | 'expired' | 'cancelled';
}

/** What an invite link is for. Public: the token itself is the secret. */
export const getInvite = (token: string) => api<InviteDetails>(`/schools/invites/${encodeURIComponent(token)}`);

/** Joins the invited school as the invited role (the email must match the invite). */
export async function registerWithInvite(email: string, name: string, token: string) {
  await api('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email: email.trim().toLowerCase(), name: name.trim(), inviteToken: token }),
  });
}

/**
 * The invite being accepted in this tab. Kept across the Google/Apple
 * redirect so the account joins the invited school instead of starting a new one.
 */
const KEY = 'educaitor.pendingInvite';
export function savePendingInvite(token: string) {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // Storage refused: signing up with email and password still works.
  }
}
export function readPendingInvite(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}
export function clearPendingInvite() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}

export const ROLE_WORD: Record<InviteDetails['role'], string> = { teacher: 'a teacher', school_leader: 'a leader' };
